module.exports = __webpack_public_path__ + "img/QA.b39ab9d6.svg";